import * as Sqrl from 'squirrelly';

// https://marketplace.visualstudio.com/items?itemName=bierner.comment-tagged-templates
const social_wall_template = /* html */`
<social-sources class="{{ it.sources }}">
{{@foreach(it.items) => key, item}}
    {{@if(it.type == 'carousel')}}
    <social-source class="swiper-slide">
    {{#else}}
    <social-source>
    {{/if}}
        <a href="{{ item.link }}">
            {{@if(it.type == 'carousel' || it.type == 'mosaic')}}
                <img class='svg' src="{{ it.svg }}#{{ item.source | lowercase }}" />
            {{/if}}
            {{@if(it.type == 'masonry')}}
                <social-title>
                    <img class='svg' src="{{ it.svg }}#{{ item.source | lowercase }}" />
                    <social-type>{{ item.source }}</social-type>
                </social-title>
            {{/if}}
            {{@if(item.image != undefined)}}
                <img loading='lazy' class="{{ item.source | lowercase }}" alt="{{ item.alt }}" src="{{ item.image }}" />
            {{/if}}
            {{@if(it.type == 'mosaic')}}
                <social-overlay></social-overlay>
            {{/if}}
            {{@if((it.type == 'masonry' || it.type == 'mosaic') && item.message.length > 0)}}
                <social-message>{{ item.message }}</social-message>
            {{/if}}
        </a>
    </social-source>
{{/foreach}}
</social-sources>
`;

document.addEventListener('DOMContentLoaded', function() {
    let socials = document.querySelectorAll('social-wall-block');
    Sqrl.filters.define("lowercase", (str) => str.toLowerCase());
    socials.forEach(function(social) {
        let items = [];
        let list = [];
        let feeds = JSON.parse(social.dataset.feeds);
        let sources = social.dataset.sources;
        feeds.forEach((feed) => 
            list.push(
                fetch(hoyry_social_wall.url+feed+'.json')
                    .then((response) => response.json())
                    .then((data) => items = items.concat(data))
            )
        );
        Promise.all(list).then(() => {
            let type;
            if (social.classList.contains('masonry')) {
                type = 'masonry';
            }
            if (social.classList.contains('carousel')) {
                type = 'carousel';
            }
            if (social.classList.contains('mosaic')) {
                type = 'mosaic';
            }
            items.sort((a,b) => (a.timestamp < b.timestamp) ? 1 : -1);
            if (type == 'carousel' || type == 'mosaic') {
                items = items.filter((item) => item.image.length > 0);
            }
            social.innerHTML += Sqrl.render(social_wall_template, {
                type: type,
                items: items,
                svg: hoyry_social_wall.svg,
                sources: sources
            });
            if (type == 'masonry') {
                if (!CSS.supports('grid-template-rows', 'masonry')) {
                    useMasonry(social);
                };
            }
            if (type == 'carousel') {
                useCarousel(social);
            }
        });
    });    
});

function useMasonry(el) {
    msnry = new Masonry(el.querySelector('social-sources'), {
        itemSelector: 'social-source',
        percentPosition: true,
        transitionDuration: 0,
    });
    imagesLoaded(el, function() {
        msnry.layout();
    });
}

function useCarousel(el) {
    let data = el.dataset;
    let args = {
        loop: true,
        navigation: {
            prevEl: 'social-control.prev',
            nextEl: 'social-control.next',
        },
        slidesPerView: Number(data.slides_sm),
        spaceBetween: 10,
        breakpoints: {
            400: {
                slidesPerView: Number(data.slides_md),
                spaceBetween: 15,
            },
            780: {
                slidesPerView: Number(data.slides_lg),
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: Number(data.slides_xl),
                spaceBetween: 25,
            },
        }
    };
    if (data.autoplay == 'true') {
        args.autoplay = {
            pauseOnMouseEnter: true,
        };
        args.delay = data.speed * 1000;
    }
    new Swiper(el, args);
}